import { database } from '../../common/firebase';
import { ref, update } from 'firebase/database';

export const savePresentationUpdates = updates =>
  update(ref(database), updates);

export const firebaseUpdatePresentationMetaData = (
  presentationId,
  metadata,
) => {
  const path = `presentations/${presentationId}`;
  var updates = {};

  Object.keys(metadata).forEach(key => {
    updates[`${path}/${key}/`] = metadata[key];
  });
  return JSON.parse(JSON.stringify(updates));
};

export const firebaseUpdateSymbol = (
  symbolId,
  name,
  content,
  tags,
  ownerId,
) => {
  return update(ref(database, `symbols/${symbolId}/`), {
    content: JSON.parse(content),
    name: name,
    tags: tags || [],
    owner_id: ownerId,
  });
};

export const firebaseUpdateSlide = (presentationId, slides, authorId) => {
  var updates = {};
  slides.forEach(slide => {
    const path = `presentations/${presentationId}/slides/${slide.id}/`;
    updates[path] = JSON.parse(
      JSON.stringify({
        ...slide,
        lastAuthorId: authorId,
        content: {
          background: '',
          ...slide.content,
        },
      }),
    );
  });

  return updates;
};

export const removeSlides = (presentationId, slides) => {
  var updates = {};
  slides &&
    slides.forEach(slide => {
      const path = `presentations/${presentationId}/slides/${slide}/`;
      updates[path] = null;
    });

  return updates;
};
